import { Field, reduxForm } from 'redux-form';
import { Grid, Form, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import {
  SelectField,
  InputField,
  DatePickerField,
  Toggle,
} from 'Common/SemanticWrapper';
import {
  STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
  STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
  STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW,
} from 'Common/Constants/';
import { DirtyWrapper } from 'Components';
import * as ManageApplicationActions from 'Pages/manageapplication/state/manageapplication/actions';
import { getDbApplication } from 'Pages/manageapplication/state/hub/selectors';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { SiteComponent } from 'Common/SiteComponent';
import { FieldEnum } from 'Common/FieldEnum';
import { ACCOUNT_SETUP_FORM_NAME } from 'Common/FormEnum';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { DropdownObjectCreator } from 'Common/ObjectHelper';
import { InputMode } from 'Common/FormEnum';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

import {
  fetchApplication,
  clearHub,
} from '../../manageapplication/state/hub/actions';
import { StudentImage } from './StudentImage';
import {
  setValidStatusFieldChanged,
  getValidStatusFromForm,
} from '../state/actions';
import {
  clearStudentImage,
  setImageStatus,
  clearStudentPictureError,
} from '../state/studentinfo/actions';
import * as StudentInfoSelectors from '../state/studentinfo/selector';

class StudentInfo extends Component {
  state = {
    grades: [],
    languages: [],
    servingNumber: '',
    servNumberChanges: false,
    imagePreview: null,
    imageStatus: STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
  };

  // generate serving number
  changeServingNumber = () => {
    this.props.getNewServingNumber();
    this.setState({ servNumberChanges: true });
  };

  componentWillUnmount() {
    this.props.clearServingNumber();
    this.setState({ servingNumber: '' });
    this.props.clearStudentImage();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      validStatusFieldChanged,
      pictureError,
      newServingNumber,
      clearStudentPictureError,
    } = this.props;

    //the onBlur event for the semantic dropdown
    //does not work.  Use a flag when billing account or
    //site changes so that we know we need to call the api
    //to get the allowed statuses
    if (
      prevProps.validStatusFieldChanged !== validStatusFieldChanged &&
      validStatusFieldChanged === true
    ) {
      this.props.getValidStatusFromForm();
    }

    if (pictureError && pictureError !== prevProps.pictureError) {
      this.removePreview();
      clearStudentPictureError();
    }

    if (newServingNumber && this.state.servNumberChanges) {
      this.props.change(`${FieldEnum.ServingNum}`, newServingNumber);
      this.setState({
        servingNumber: newServingNumber,
        servNumberChanges: false,
      });
    }
  }

  // @todo refactor to use componentDidUpdate
  componentWillReceiveProps(nextProps) {
    // generate grades object
    if (this.state.grades.length === 0) {
      const grades =
        nextProps.grades &&
        DropdownObjectCreator(nextProps.grades, 'Id', 'Description', true);
      nextProps.grades && this.setState({ grades: grades });
    }
    // generates languages object
    if (this.state.languages.length === 0) {
      const languages =
        nextProps.languages &&
        nextProps.languages.Data &&
        DropdownObjectCreator(nextProps.languages.Data, 'Id', 'Description');
      nextProps.languages &&
        nextProps.languages.Data &&
        this.setState({ languages: languages });
    }

    if (nextProps.studentImage) {
      this.setState({
        imageStatus: STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
      });
    }

    const { studentSeedData, fetchApplication } = this.props;
    const { studentSeedData: nextStudentSeedData } = nextProps;
    const familyId = _.get(studentSeedData, 'FamilyId', 0);
    const nextFamilyId = _.get(nextStudentSeedData, 'FamilyId', 0);

    if (familyId !== nextFamilyId && (nextFamilyId || 0) !== 0) {
      fetchApplication(nextFamilyId);
    }
  }

  onDrop = (files) => {
    if (files[0] !== undefined && files[0] !== 0) {
      this.setState({
        imagePreview: files[0],
      });
      this.props.setImageStatus(STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW);
      this.props.change(FieldEnum.StudentInfoImage, files[0]);
      this.props.setStudentImage(files[0]);
    }
  };

  removePreview = () => {
    const { change, setImageStatus } = this.props;

    setImageStatus(STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE);
    change(FieldEnum.StudentInfoImage, '');
    this.setState({
      imagePreview: null,
    });
    this.props.setStudentImage(null);
  };

  changeStudentNumber = (e) => {
    const { isNew, change } = this.props;
    if (isNew) {
      change(`${FieldEnum.ServingNum}`, e.target.value);
      change(`${FieldEnum.BillingAcc}`, e.target.value);
    }
  };

  goToApp = (FamilyId) => () => {
    this.props.clearHub();
    this.props.history.push(
      `/manageapplication/${FamilyId === null ? 0 : FamilyId}`
    );
  };

  getStudent = () => {
    const { application, studentSeedData } = this.props;
    const studentId = _.get(studentSeedData, 'Id', 0);
    if (studentId === 0) {
      return;
    }

    const filtered = _.get(application, 'Students', []).filter(
      (s) => s.Id === studentId
    );
    return filtered.length > 0 ? filtered[0] : null;
  };

  handleCEPTransferToggle = (e, checked) => {
    const { application, change, studentSeedData } = this.props;

    const { statusCurrent, statusFuture, statusPrevious } =
      this.getStatuses(studentSeedData);
    const hasApplication = !_.isNil(application);

    if (!checked || (hasApplication && statusCurrent === StatusEnum.Free)) {
      change(FieldEnum.StatusCurrent, statusCurrent);
      change(FieldEnum.StatusFuture, statusFuture);
      change(FieldEnum.StatusPrevious, statusPrevious);
      return;
    }

    change(FieldEnum.StatusPrevious, statusCurrent);
    change(FieldEnum.StatusCurrent, StatusEnum.Free);
    change(
      FieldEnum.StatusFuture,
      hasApplication
        ? statusCurrent === StatusEnum.Reduced
          ? StatusEnum.Reduced
          : StatusEnum.Paid
        : StatusEnum.Paid
    );
  };

  getStatuses = (student) => {
    const statusCurrent = _.get(student, 'StatusCurrent', '');
    const statusFuture = _.get(student, 'StatusFuture', '');
    const statusPrevious = _.get(student, 'StatusPrevious', '');
    return { statusCurrent, statusFuture, statusPrevious };
  };

  render() {
    const {
      handleSubmit,
      validStatus,
      studentSeedData,
      isNew,
      isReadOnly,
      studentInfo = {},
      initialValues,
      setAutoPopulateStudentData,
      newValidStatus,
      isCEPOrProvision2Site,
    } = this.props;

    const { languages, grades, imagePreview } = this.state;
    const { studentImage, imageStatus } = studentInfo;

    const { statusCurrent } = this.getStatuses(studentSeedData);
    const enableCEPToggle =
      !isCEPOrProvision2Site &&
      !initialValues.CEP_Transfer &&
      statusCurrent >= StatusEnum.Free &&
      statusCurrent <= StatusEnum.Paid;

    return (
      <section className="student-form-component grid-spacing">
        <Form onSubmit={handleSubmit}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={3}>
                <StudentImage
                  status={imageStatus}
                  imagePreview={imagePreview}
                  studentImage={studentImage}
                  onDrop={this.onDrop}
                  removePreview={this.removePreview}
                  changeStudentImage={this.removePreview}
                  isReadOnly={isReadOnly}
                />
                <Field
                  name={FieldEnum.StudentInfoImage}
                  component={InputField}
                  type="hidden"
                  label={false}
                  //tabIndex={-1}
                />
              </Grid.Column>
              <Grid.Column width={13}>
                <Grid className="tight">
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.FirstName}
                        component={InputField}
                        type="text"
                        maxLength={20}
                        label={'First Name'}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.LastName}
                        component={InputField}
                        type="text"
                        maxLength={20}
                        label={'Last Name'}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <SiteComponent
                        name={FieldEnum.SiteId}
                        {...this.props}
                        isForm={true}
                        isAllRequired={false}
                        //tabIndex={3}
                        onChange={this.props.setValidStatusFieldChanged}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <SecurityPreferences scope={PrefEnum.ChangeStudentNumber}>
                        {(disabled) => {
                          return (
                            <Field
                              name={FieldEnum.Id}
                              component={InputField}
                              type="text"
                              maxLength={12}
                              mode={InputMode.Integer}
                              minLength={3}
                              label={'student #'}
                              onChange={(e) => this.changeStudentNumber(e)}
                              disabled={!isNew || disabled}
                            />
                          );
                        }}
                      </SecurityPreferences>
                      <Field
                        name={FieldEnum.IdSeed}
                        component={'input'}
                        type="hidden"
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.ServingNum}
                        component={InputField}
                        type="text"
                        maxLength={12}
                        minLength={3}
                        mode={InputMode.Integer}
                        label={'Serving #'}
                        //tabIndex={5}
                        action={
                          <Button
                            type="button"
                            icon="refresh"
                            onClick={this.changeServingNumber}
                          />
                        }
                      />
                    </Grid.Column>

                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.BillingAcc}
                        component={InputField}
                        type="text"
                        label={'Billing Account #'}
                        //tabIndex={6}
                        maxLength={12}
                        minLength={3}
                        mode={InputMode.Integer}
                        onChange={this.props.setValidStatusFieldChanged}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.StateNum}
                        component={InputField}
                        type="text"
                        label={'State #'}
                        maxLength={25}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.Teacher}
                        component={InputField}
                        type="text"
                        maxLength={20}
                        label={'Teacher'}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.Grade}
                        component={SelectField}
                        type="text"
                        label={'Grade'}
                        options={grades}
                        fluid
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.LanguageId}
                        component={SelectField}
                        type="text"
                        label={'Language'}
                        options={languages}
                        fluid
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.BirthDate}
                        component={DatePickerField}
                        type="text"
                        label="DOB"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.FamilyIdentifier}
                        component={InputField}
                        type="text"
                        label="Family ID"
                        maxLength={12}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.HomeRoom}
                        component={InputField}
                        type="text"
                        label="HomeRoom #"
                        maxLength={20}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4} verticalAlign="middle">
                      <Field
                        name={FieldEnum.NonLea}
                        component={Toggle}
                        label={'Non-LEA'}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.Message}
                        component={InputField}
                        type="text"
                        maxLength={50}
                        label={'Special Message'}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row style={{ paddingBottom: '1rem' }}>
                    <Grid.Column width={8}>
                      <label className="text-orange">Status</label>
                    </Grid.Column>

                    <Grid.Column width={8}>
                      <label className="text-orange">Finances</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        name={FieldEnum.CEP_Transfer}
                        component={Toggle}
                        label={'CEP Transfer'}
                        disabled={!enableCEPToggle}
                        onChange={this.handleCEPTransferToggle}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      {validStatus.length > 0 && (
                        <SecurityPreferences
                          scope={PrefEnum.ChangeStudentStatus}
                        >
                          {(disabled) => {
                            return (
                              <Field
                                search={false}
                                name={FieldEnum.StatusCurrent}
                                component={SelectField}
                                label={'Current'}
                                options={newValidStatus}
                                disabled={disabled}
                                fluid
                                upward
                              />
                            );
                          }}
                        </SecurityPreferences>
                      )}
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.StatusPrevious}
                        component={InputField}
                        type="number"
                        label={'Previous'}
                        disabled={true}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Grid className="input-group--monetary finances-section">
                        <Grid.Row className="remove-spacing row--grouped" />
                        {studentSeedData &&
                        studentSeedData.Id !== studentSeedData.BillingAcc &&
                        studentSeedData.StatusCurrent !== '9' ? (
                          <Grid.Row>
                            <Grid.Column>
                              <label>
                                Balance adjustments to this account must be made
                                under Account# {studentSeedData.BillingAcc}
                              </label>
                            </Grid.Column>
                          </Grid.Row>
                        ) : (
                          <React.Fragment>
                            <Grid.Row className="remove-spacing row--grouped">
                              <Grid.Column>
                                <Field
                                  name={FieldEnum.Payments}
                                  component={InputField}
                                  type="text"
                                  mode={InputMode.Decimal}
                                  disabled={true}
                                  label={false}
                                  fieldLabel={{
                                    tag: true,
                                    content: 'Payments',
                                  }}
                                  labelPosition="right"
                                  format={(value) => {
                                    return `$${value}`;
                                  }}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="remove-spacing row--grouped">
                              <Grid.Column>
                                <Field
                                  name={FieldEnum.Purchases}
                                  component={InputField}
                                  type="text"
                                  mode={InputMode.Decimal}
                                  disabled={true}
                                  label={false}
                                  fieldLabel={{
                                    tag: true,
                                    content: 'Purchases',
                                  }}
                                  labelPosition="right"
                                  format={(value) => {
                                    return `$${value}`;
                                  }}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="remove-spacing row--grouped">
                              <Grid.Column>
                                <Field
                                  name={FieldEnum.Balance}
                                  component={InputField}
                                  type="text"
                                  disabled={true}
                                  label={false}
                                  className={
                                    initialValues.balance < 0
                                      ? 'text--error'
                                      : ''
                                  }
                                  fieldLabel={{
                                    tag: true,
                                    content: 'Balance',
                                  }}
                                  labelPosition="right"
                                  format={(value) => {
                                    return `$${value}`;
                                  }}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </React.Fragment>
                        )}
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>

                  {!isNew && (
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Form.Field>
                          <label>
                            {`Effective Date:  ${
                              studentSeedData && studentSeedData.EffectiveDate
                            }`}
                          </label>
                          <DirtyWrapper
                            closeModalYesCallback={this.goToApp(
                              studentSeedData ? studentSeedData.FamilyId : 0
                            )}
                          >
                            {(showDirtyConfirm) => {
                              const familyId = _.get(
                                studentSeedData,
                                'FamilyId',
                                0
                              );
                              const isNewApplication =
                                familyId === null || familyId === 0;
                              return studentSeedData ? (
                                <a
                                  href={`/manageapplication/${
                                    isNewApplication ? 0 : familyId
                                  }`}
                                  onClick={(e, v) => {
                                    e.preventDefault();
                                    showDirtyConfirm(e, v);

                                    if (isNewApplication) {
                                      setAutoPopulateStudentData(
                                        studentSeedData
                                      );
                                    }
                                  }}
                                >
                                  {isNewApplication
                                    ? 'NEW APPLICATION'
                                    : 'GO TO APPLICATION'}
                                </a>
                              ) : undefined;
                            }}
                          </DirtyWrapper>
                        </Form.Field>
                      </Grid.Column>
                    </Grid.Row>
                  )}
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </section>
    );
  }
}
const validate = (values, props) => {
  const errors = {};

  if (!values[FieldEnum.Id] || _.trim(values[FieldEnum.Id]).length === 0) {
    errors[FieldEnum.Id] = 'Id is required.';
  }
  if (
    !values[FieldEnum.ServingNum] ||
    _.trim(values[FieldEnum.ServingNum]).length === 0
  ) {
    errors[FieldEnum.ServingNum] = 'Serving number is required.';
  }

  if (
    !values[FieldEnum.BillingAcc] ||
    _.trim(values[FieldEnum.BillingAcc]).length === 0
  ) {
    errors[FieldEnum.BillingAcc] = 'Billing Account is required.';
  }

  if (
    !values[FieldEnum.ServingNum] ||
    _.trim(values[FieldEnum.ServingNum]).length < 3 ||
    _.trim(values[FieldEnum.ServingNum]).length > 12
  ) {
    errors[FieldEnum.ServingNum] = 'Serving number must be between 3 and 12';
  }
  if (
    !values[FieldEnum.BillingAcc] ||
    _.trim(values[FieldEnum.BillingAcc]).length < 3 ||
    _.trim(values[FieldEnum.BillingAcc]).length > 12
  ) {
    errors[FieldEnum.BillingAcc] = 'Billing Account must be between 3 and 12';
  }
  if (
    !values[FieldEnum.Id] ||
    _.trim(values[FieldEnum.Id]).length < 3 ||
    _.trim(values[FieldEnum.Id]).length > 12
  ) {
    errors[FieldEnum.Id] = 'Student number must be between 3 and 12';
  }

  if (
    !values[FieldEnum.FirstName] ||
    _.trim(values[FieldEnum.FirstName]).length === 0
  ) {
    errors[FieldEnum.FirstName] = 'First name is required.';
  }
  if (
    !values[FieldEnum.LastName] ||
    _.trim(values[FieldEnum.LastName]).length === 0
  ) {
    errors[FieldEnum.LastName] = 'Last name is required.';
  }
  if (
    !values[FieldEnum.StatusCurrent] ||
    _.trim(values[FieldEnum.StatusCurrent]).length === 0
  ) {
    errors[FieldEnum.StatusCurrent] = 'Current status is required.';
  }
  if (!values[FieldEnum.SiteId]) {
    errors[FieldEnum.SiteId] = 'Site Id required';
  }

  if (values[FieldEnum.BillingAcc] && isNaN(values[FieldEnum.BillingAcc])) {
    errors[FieldEnum.BillingAcc] = 'Please enter a valid Billing Account.';
  }

  if (moment(values[FieldEnum.BirthDate], 'MM/DD/YYYY').isValid()) {
    if (
      moment(values[FieldEnum.BirthDate], 'MM/DD/YYYY').inspect() ===
        'invalid date' ||
      !moment(moment(values[FieldEnum.BirthDate])).isAfter('1901-01-01')
    ) {
      errors[FieldEnum.BirthDate] = 'Letter date is invalid.';
    }
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    validStatusFieldChanged:
      StudentInfoSelectors.getValidStatusFieldChanged(state),
    validStatus: StudentInfoSelectors.getValidStatusMessage(state),
    studentImage: StudentInfoSelectors.getStudentImage(state),
    newValidStatus: StudentInfoSelectors.getValidStatus(state),
    application: getDbApplication(state),
  };
};

const mapDispatchToProps = {
  setValidStatusFieldChanged,
  getValidStatusFromForm,
  clearStudentImage,
  clearHub,
  fetchApplication,
  setImageStatus,
  clearStudentPictureError,
  setAutoPopulateStudentData:
    ManageApplicationActions.setAutoPopulateStudentData,
};

StudentInfo = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StudentInfo)
);

export default reduxForm({
  validate,
  enableReinitialize: true,
  form: ACCOUNT_SETUP_FORM_NAME,
})(StudentInfo);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentInfo.js